module.exports = __webpack_public_path__ + "./img/loginBG.png?7f9de74db6a24775bce721a41c088e19";